import registrationInstance from './registration/instance'
import { getGlobalStore } from '../../store/globalStore'
import { endSessionThunk, isSessionRejectedByServer } from '../thunk/session'
import { refreshAccessToken } from './refreshAccessToken'

const NOT_REFRESHABLE_URLS = ['/auth/login', '/register/passwordless']

const responseInterceptor = error => {
  const store = getGlobalStore()
  const originalRequest = error.config

  if (error?.response?.status !== 401) {
    return Promise.reject(error)
  }

  if (NOT_REFRESHABLE_URLS.includes(originalRequest.url)) {
    return Promise.reject(error)
  }

  if (originalRequest._retry) {
    return Promise.reject(error)
  }

  if (!store.dispatch) {
    return Promise.reject(error)
  }

  originalRequest._retry = true

  return refreshAccessToken()
    .catch(refreshError => {
      if (isSessionRejectedByServer(refreshError)) {
        store.dispatch(endSessionThunk())
      }

      return Promise.reject(refreshError)
    })
    .then(accessToken => {
      originalRequest.headers['Authorization'] = `Bearer ${accessToken}`

      return registrationInstance(originalRequest)
    })
}

export default responseInterceptor
